module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp12_8004.7bd9ffb7.png";